var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.question.number)+". "+_vm._s(_vm.question.question))]),_c('Options',{attrs:{"question":_vm.question.id,"options":_vm.question.options,"answer":_vm.answer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }